import TopMenu from "@/components/TopMenu";
import { ScrollView } from "devextreme-react";
import { isMobile } from "@/helper/helper";
import { Outlet, useLocation } from "react-router";
import HouseholdMenu from "./HouseholdMenu";
import { useAppSelector } from "@hooks/useAppSelector";
import { npvActions } from "@redux/npv/npv-slice";
import NavigationBlocker from "@/components/NavigationBlocker";
import { useQueryClient } from "@tanstack/react-query";
import { uqActions } from "@/redux/uq/uq-slice";
import withAuth from "@/hoc/withAuth";
import { Link } from "react-router-dom";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import AppVersion from "@/components/AppVersion";
import { IS_PRODUCTION } from "@/constants/constants";

function HouseHoldLayout() {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { isModified: npvModified } = useAppSelector((state) => state.npv);
  const { pathname } = useLocation();
  const isNpv = pathname.toLocaleLowerCase().includes("npv");
  const isAB = pathname.toLocaleLowerCase().includes("allocation-blueprint");

  const currentPageName = pathname.split("/")[3];

  const handleRefresh = () => {
    if (npvModified) {
      dispatch(uqActions.setShowRestorePopup(true));
      return;
    }

    // This assumes query keys are named after the page names. Please validate next time you add a new page under household.
    // Exception for SG which consumes up data.
    const queryKey = isAB ? "unique-possibilities" : currentPageName;
    queryClient.refetchQueries({
      queryKey: [queryKey],
      exact: false,
    });

    dispatch(npvActions.setIsModified(false));
  };

  return (
    <>
      <NavigationBlocker />
      {!IS_PRODUCTION ? <AppVersion isWithinHousehold /> : null}
      <div className="h-full">
        <TopMenu inContext={true} />
        <div className="household-wrapper">
          <main
            className={`main_container print:w-[calc(100vw-4px)] print:max-w-[calc(100vw-4px)]`}
          >
            <div className="flex items-center justify-between bg-white px-8 py-3 print:hidden">
              <Link to={"/household"} className="flex h-11 w-max items-center gap-2">
                <img src="/icons/left-chevron-icon.svg" alt="" />
                <span className="text-sm">Exit</span>
              </Link>
              <div className="flex items-center">
                <div id="action-btns" />
                {!isNpv ? (
                  <button className="flex h-11 w-max items-center" onClick={handleRefresh}>
                    <img src="/icons/refresh-icon.svg" />
                    <span className="pl-1">Refresh</span>
                  </button>
                ) : null}
              </div>
            </div>
            <ScrollView
              id="household-scrollview"
              className={`pb-[2rem] print:h-full print:min-h-full print:scroll-m-2 print:pt-6 ${
                isMobile.any() ? "h-[calc(100dvh-11.875rem)]" : "h-[calc(100dvh-190px)]"
              }`}
            >
              <div id="hh-layout" className="text-xs sm:text-base screen:px-8 screen:pb-8">
                <Outlet />
              </div>
            </ScrollView>
          </main>
        </div>
        <HouseholdMenu />
      </div>
    </>
  );
}

export default withAuth(HouseHoldLayout);
